import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';

export const PageHeader = ({ title, subtitle, backTo, actions }) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
      <div>
        {backTo && (
          <button
            onClick={() => navigate(backTo)}
            className="flex items-center gap-1 text-muted-foreground hover:text-foreground text-sm font-ui mb-2 transition-colors"
          >
            <ChevronLeft size={16} />
            Nazad
          </button>
        )}
        <h1 className="font-serif text-2xl md:text-3xl font-semibold text-foreground">{title}</h1>
        {subtitle && <p className="text-muted-foreground text-sm font-ui mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex w-full sm:w-auto items-center gap-3 sm:justify-end">{actions}</div>}
    </div>
  );
};
